import React from 'react';

import SectionTabs from '../../section-tabs';

function StoryblokTabsAdapter({ sections }) {
  return <SectionTabs items={sections} />;
}

export default StoryblokTabsAdapter;
